module.exports = __webpack_public_path__ + "img/l-1.a0667ea8.png";